var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import classNames from 'classnames';

import { Editor } from 'draft-js';

import 'draft-js/dist/Draft.css';

import Label from '../label';
import Tooltip from '../tooltip';

import './DraftJSEditor.scss';

var DraftJSEditor = function (_React$Component) {
    _inherits(DraftJSEditor, _React$Component);

    function DraftJSEditor(props) {
        _classCallCheck(this, DraftJSEditor);

        var _this = _possibleConstructorReturn(this, (DraftJSEditor.__proto__ || Object.getPrototypeOf(DraftJSEditor)).call(this, props));

        _this.handleChange = function (editorState) {
            var onChange = _this.props.onChange;


            onChange(editorState);
        };

        _this.handleBlur = function (editorState) {
            var onBlur = _this.props.onBlur;


            onBlur(editorState);
        };

        _this.handleReturn = function (event) {
            var _this$props = _this.props,
                onReturn = _this$props.onReturn,
                inputProps = _this$props.inputProps;


            if (onReturn && !inputProps['aria-activedescendant']) {
                // Return 'handled' tells DraftJS Editor to not handle return key event,
                // return 'not-handled' tells DraftJS Editor to continue handle the return key event.
                // We encapsulate this DraftJS Editor specific contract here, and use true/fase
                // to indicate whether to let DraftJS Editor handle return event or not in the upper level.
                return onReturn(event) ? 'handled' : 'not-handled';
            }

            return 'not-handled';
        };

        _this.state = {
            error: props.error
        };
        return _this;
    }

    /**
     * Calls onChange handler passed in
     * @param {EditorState} editorState The new/updated editor state
     * @returns {void}
     */


    /**
     * Event handler which being passed to 'handleReturn' prop of DraftJSEditor
     * This gives consumer the ability to handle return key event before DraftJSEditor handles it.
     * @param {SyntheticKeyboardEvent} event
     * @returns {string}
     */


    _createClass(DraftJSEditor, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                editorState = _props.editorState,
                error = _props.error,
                hideLabel = _props.hideLabel,
                inputProps = _props.inputProps,
                isDisabled = _props.isDisabled,
                isRequired = _props.isRequired,
                label = _props.label,
                onFocus = _props.onFocus,
                placeholder = _props.placeholder;
            var handleBlur = this.handleBlur,
                handleChange = this.handleChange;


            var classes = classNames({
                'draft-js-editor': true,
                'is-disabled': isDisabled,
                'show-error': !!error
            });

            var a11yProps = {};
            if (inputProps.role) {
                a11yProps = {
                    ariaActiveDescendantID: inputProps['aria-activedescendant'],
                    ariaAutoComplete: inputProps['aria-autocomplete'],
                    ariaExpanded: inputProps['aria-expanded'],
                    ariaOwneeID: inputProps['aria-owns'],
                    role: inputProps.role
                };
            }

            return React.createElement(
                'div',
                { className: classes },
                React.createElement(
                    Label,
                    {
                        text: label,
                        showOptionalText: !isRequired,
                        hideLabel: hideLabel
                    },
                    React.createElement(
                        Tooltip,
                        {
                            isShown: !!error,
                            text: error ? error.message : '',
                            theme: 'error',
                            position: 'bottom-left'
                        },
                        React.createElement(
                            'div',
                            null,
                            React.createElement(Editor, _extends({}, a11yProps, {
                                editorState: editorState,
                                onBlur: handleBlur,
                                onChange: handleChange,
                                onFocus: onFocus,
                                placeholder: placeholder,
                                readOnly: isDisabled,
                                handleReturn: this.handleReturn,
                                stripPastedStyles: true
                            }))
                        )
                    )
                )
            );
        }
    }]);

    return DraftJSEditor;
}(React.Component);

DraftJSEditor.defaultProps = {
    inputProps: {},
    isRequired: false,
    isFocused: false
};
DraftJSEditor.propTypes = {
    editorState: function editorState() {
        return (typeof bpfrpt_proptype_EditorState === 'function' ? bpfrpt_proptype_EditorState.isRequired ? bpfrpt_proptype_EditorState.isRequired : bpfrpt_proptype_EditorState : PropTypes.shape(bpfrpt_proptype_EditorState).isRequired).apply(this, arguments);
    },
    error: PropTypes.object,
    hideLabel: PropTypes.bool,
    inputProps: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    label: PropTypes.node.isRequired,
    onBlur: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onReturn: PropTypes.func,
    placeholder: PropTypes.string
};


export default DraftJSEditor;
import { bpfrpt_proptype_EditorState } from 'draft-js';
import PropTypes from 'prop-types';